export default "__VITE_ASSET__BhIlhMKS__"